import { DataConnector, DataConnectorStatus } from "@/api/data-connectors";

import { DataConnectorCard } from "./DataConnectorCard";

type Props = {
  dataConnectors: DataConnector[];
  onEdit?: (dc: DataConnector) => void;
  onSetStatus?: (dc: DataConnector, status: DataConnectorStatus) => void;
};

export function DataConnectorList({
  dataConnectors,
  onEdit,
  onSetStatus,
}: Props) {
  return (
    <div className="flex flex-col gap-3">
      {dataConnectors.map((dc) => (
        <DataConnectorCard
          key={dc.id}
          dataConnector={dc}
          onEdit={onEdit}
          onSetStatus={onSetStatus}
        />
      ))}
    </div>
  );
}

export function DataConnectorListSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      {new Array(5).fill(0).map((_, i) => (
        <div
          key={i}
          className="border-borderSubtle bg-surface-default flex min-h-[90px] animate-pulse items-center gap-5 rounded-xl border border-solid px-[21px] py-[17px]"
        >
          <div className="bg-surface-muted h-12 w-12 shrink-0 rounded-lg" />
          <div className="flex flex-1 flex-col gap-2">
            <div className="bg-surface-muted h-4 w-1/3 rounded" />
            <div className="bg-surface-muted h-3 w-1/4 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
